// Gap kept between the row menu and the viewport edge whenever a clamp kicks in, on any side.
export const DROPDOWN_EDGE_PADDING = 8;

/**
 * Vertical position for a `position: fixed` dropdown anchored to a trigger element (the
 * three-dots menu in File/Folder rows). position: fixed is viewport-relative, so no scrollY
 * offset belongs here — and since there's no bottom-of-viewport check otherwise, rows near the
 * bottom of the screen would render their menu partly or fully off-screen. Flips the menu above
 * the trigger when there isn't room to open downward, using the menu's real (already-mounted)
 * height.
 */
export const computeDropdownTop = (triggerRect: DOMRect, dropdownHeight: number): number => {
    const spaceBelow = window.innerHeight - triggerRect.bottom;
    const openUpward = dropdownHeight > 0 && spaceBelow < dropdownHeight;
    return openUpward ? Math.max(triggerRect.top - dropdownHeight, DROPDOWN_EDGE_PADDING) : triggerRect.bottom;
};

/**
 * Horizontal position for the same dropdown. It sits 50px left of the trigger so the menu overlaps
 * the row rather than the scrollbar, but the three-dots icon lives at the row's right end, so most
 * rows would push a wide menu off the right viewport edge. Clamps to 8px inside both edges, right
 * edge first — a menu wider than the viewport ends up flush left rather than off-screen.
 */
export const computeDropdownLeft = (triggerRect: DOMRect, dropdownWidth: number): number => {
    const left = Math.min(triggerRect.left - 50, window.innerWidth - dropdownWidth - DROPDOWN_EDGE_PADDING);
    return Math.max(left, DROPDOWN_EDGE_PADDING);
};
